import { concatClasses } from "../../../helpers/concatClasses/index.js";
const getLabelClasses = ({ dsf_size }) => {
  const classes = [];
  classes.push(dsf_size === "small" ? "dsf-text-xxs" : "dsf-text-xs");
  classes.push(dsf_size === "small" ? "mb-2" : "mb-4");
  return concatClasses(classes);
};
export {
  getLabelClasses
};
